import { QueryClient } from "react-query";

export default new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 60 * 60 * 1000,//60 minutes
            staleTime: 60 * 60 * 1000,//60 minutes
        },
    },
});
